module.exports = __webpack_public_path__ + "img/_3.b0d5fa38.png";